import ProspectorProApiService from './ProspectorProApiService';

export default class CrmProviderService extends ProspectorProApiService {
  constructor(apiHandler) {
    super(apiHandler);
    this.createUrl = '/CRMProviderREST/add-provider';
    this.getAllUrl = '/CRMProviderREST/all';
  }

  getTypes() {
    return this.get('/CRMProviderREST/types');
  }

  updateAuthStatus(identifier, data) {
    return this.put(`/CRMProviderREST/update-provider-auth-status/${identifier}`, data);
  }

  authenticate(data) {
    return this.post('/CRMProviderREST/auth-crm-user', data);
  }
}
